import React from "react";
const TabItem = ({ title, children }) => {
  return children;
};
export default TabItem;
